/*
 * Register the Service Worker for off-line support
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
    navigator.serviceWorker.register('/sw-001.js').then(function(registration) {
      // Registration was successful
      // console.log('ServiceWorker registration successful with scope: ', registration.scope);
    }).catch(function(err) {
      // registration failed :(
      // console.log('ServiceWorker registration failed: ', err);
    });
  });
} else {
    // console.log('ServiceWorker not supported');
}


/*
 * The main website JS.
 */
// (function ($) {
(function ($, Drupal) {

    /*
     * Helper function for re-styling the image upload widget
     *
     * @see: karavip_image_widget($variables) in template.php
     */
    // Drupal.behaviors.uploadfunctionAddClass = {
        // attach: function (context, settings) {
//
            // // When an image is uploaded using the upload widget
            // // we change the "Click to browse for an image" text with the file name
            // $(":file").change(function(){
                // $(this).prev().prev().text($(this).val());
            // });
//
            // // After the "Upload" button is clicked, we style the preview image.
            // if ($('.image-preview').is(':visible')) {
                // $('.browse-button').hide();
                // $('.file-name').hide();
                // $('.image-preview').css({'padding-bottom': '0'});
                // $('.image-widget-data').css({'background-color': 'transparent'});
                // $('.image-widget-data').css({'border-bottom': '1px solid #ffffff'});
                // $('.image-widget-data').css({'padding': '5px 5px 0 5px'});
                // $('.image-widget-data').css({'left': '470px'});
                // $('.image-widget-data').css({'height': '40px'});
                // $('.image-widget-data').css({'width': '350px'});
            // }
        // }
    // };


    /**
     * Stop background scroll when colorbox is open
     */
    $(document).bind('cbox_open', function() {
      $('html').addClass("noScrollSimple");
    }).bind('cbox_cleanup', function() {
      $('html').removeClass("noScrollSimple");
    });


    /**
     * Fix Order List exposed filters checkboxes
     */
    Drupal.behaviors.fixOrderListExposedFiltersCheckboxes = {
        attach: function ( context, settings ) {
            $('button.view-exposed-filters-cog',context).on('click', function() {
                $('.views-exposed-form .modal-body .bef-select-as-checkboxes',context).removeClass('form-control');
                $('.views-exposed-form .modal-body .bef-checkboxes',context).removeClass('form-control');
                $('.views-exposed-form .modal-body .bef-checkboxes input',context).removeClass('form-control').addClass('form-checkbox');
            });
            $('#edit-submit-shopping-cart',context).on('click', function() {
                $('#filterModal').modal('hide');
            });
        }
    };


    /**
     * Show message boxes (status, warning, error), one below the other.
     * @see kvip-themes.scss > .messages
     */
    // $(document).ready(function() {
    //     var topPosition = 20;
    //     insertionQ('.messages').every(function(element){
    //         $(document).on('click',function(event) {
    //             topPosition = 20;
    //         });
    //
    //         $(element).css('top', topPosition + 'px');
    //         $(element).addClass('message-visible');
    //         topPosition = topPosition + element.offsetHeight + 20;
    //         hideAlertMessages();
    //     });
    //     hideAlertMessages();
    // });

    function hideAlertMessages() {
      var timer;
      timer = setTimeout(function() {
          $(".messages").fadeOut(1000, function() {
              $(this).remove();
          });
      }, 4000);

      // If the user hovers over the div, clear the timeout
      $(".messages").hover(function() {
          clearTimeout(timer);
      }, function() {
          // Restart the timer if the user moves the mouse out
          timer = setTimeout(function() {
              $(".messages").fadeOut(1000, function() {
                  $(this).remove();
              });
          }, 2000);
      });
    }


   /**
    * Remove all '.is-empty' classes from the select boxes labels
    * transformed using dropdownjs. This will prevent the label
    * overlaping the value of the select box, when the field does
    * not have focus.
    */
    $(document).ready(function () {
      $('.form-type-select.label-floating').removeClass('is-empty');
    });
    Drupal.behaviors.fixMaterialDropdownJSLabels = {
      attach: function (context, settings) {
        $('.form-type-select.label-floating', context).once('fix-dropdownjs-material-labels').removeClass('is-empty');
      }
    };


    /**
     * Diamonds Filters - hide "Marime" field when this attribute does not
     * apply to the product category (ex. "Cercei").
     */
    Drupal.behaviors.changeDiamondsSizeStateBEF = {
        attach: function ( context, settings ) {

          // Change the visibility of the "Marime" field on modal opening,
          // depending on its value.
          // Note: The modal used here is Bootstrap 4 Modal.
          var selectedDiamondCateg = $('#views-exposed-form-lista-bijuterii-page-grid-diamante #edit-field-categorie-produs-value', context);
          diamondSizeVisibility(selectedDiamondCateg.val());

          $('#filterModal').on('show.bs.modal', function() {
            console.log('opened modal');
            var diamondCateg = $('#views-exposed-form-lista-bijuterii-page-grid-diamante #edit-field-categorie-produs-value', context);
            console.log('open modal value = ' + diamondCateg.val());
            diamondSizeVisibility(diamondCateg.val());
          });

          // Change the "Marime" field visibility on desktop
          $('#views-exposed-form-lista-bijuterii-page-grid-diamante #edit-field-categorie-produs-value', context).on('change', function() {
            console.log('changed');
            console.log('change value = ' + this.value);
            diamondSizeVisibility(this.value);
          });
        }
    };
    function diamondSizeVisibility(diamondCategValue) {
      // console.log('function = ' + diamondCategValue);
      // if (diamondCategValue == 'All' ||
      //     (diamondCategValue != 1 &&    // Inele
      //      diamondCategValue != 5 &&    // Lanturi
      //      diamondCategValue != 6 &&    // Coliere
      //      diamondCategValue != 7 &&    // Bratari
      //      diamondCategValue != 8 &&    // Bratari de picior
      //      diamondCategValue != 13)) {   // Inele de logodna
      //   $('input#edit-field-marime-value').val('');
      //   $('div#edit-field-marime-value-wrapper').hide(400);
      // } else {
      //   $('div#edit-field-marime-value-wrapper').show(400);
      // }
    }


    /**
     * Capitalize the first letter of the engraving text fields.
     */
    Drupal.behaviors.capitalizeTextFirstLetter = {
        attach: function ( context, settings ) {
            $('.field-name-field-gravura-fata input, .field-name-field-gravura-verso input, .field-name-field-text-inscriptionat input, .field-name-field-text-barbat input', context).on('propertychange change click keyup input paste', function() {
                $(this).val(capitalizeFirstLetter($(this).val(),false));
            });
        }
    };


    /**
     * Show the text preview using the available fonts on the order forms
     */
    Drupal.behaviors.fontTextPreview = {
        attach: function ( context, settings ) {
            var stopLength;

            // Limit number of characters to 15
            $('.field-name-field-text input', context).attr('maxlength', 15);

            $('.field-name-field-text input', context).on('propertychange change click keyup input paste', function() {
                $(this).val(capitalizeFirstLetter($(this).val(), true));

                var textValue = $(this).val();

                // stopLength controls when to allow changing the option labels.
                if (textValue.length <= 20) {
                    stopLength = false;
                } else {
                    stopLength = true;
                }

                if (!stopLength) {
                    // the displated sample text won't be longer than 20 characters.
                    if (textValue.length < 20) {
                        $('.field-name-field-font .font-ballantines').text((textValue != '') ? textValue : 'Ballantines Heavy (Kara)');
                        $('.field-name-field-font .font-brush').text((textValue != '') ? textValue : 'Brush');
                        $('.field-name-field-font .font-nelson').text((textValue != '') ? textValue : 'Nelson');
                        $('.field-name-field-font .font-monotype').text((textValue != '') ? textValue : 'Monotype Corsiva');
                        $('.field-name-field-font .font-amaze').text((textValue != '') ? textValue : 'Amaze');
                        $('.field-name-field-font .font-script-mt').text((textValue != '') ? textValue : 'Script MT');
                        $('.field-name-field-font .font-fiolex').text((textValue != '') ? textValue : 'Fiolex Girls');

                        $('.field-name-field-font-br .font-ballantines').text((textValue != '') ? textValue : 'Ballantines Heavy (Kara)');
                        $('.field-name-field-font-br .font-brush').text((textValue != '') ? textValue : 'Brush');
                        $('.field-name-field-font-br .font-nelson').text((textValue != '') ? textValue : 'Nelson');
                        $('.field-name-field-font-br .font-monotype').text((textValue != '') ? textValue : 'Monotype Corsiva');
                        $('.field-name-field-font-br .font-amaze').text((textValue != '') ? textValue : 'Amaze');
                        $('.field-name-field-font-br .font-script-mt').text((textValue != '') ? textValue : 'Script MT');
                        $('.field-name-field-font-br .font-fiolex').text((textValue != '') ? textValue : 'Fiolex Girls');
                    } else {
                        $('.field-name-field-font .font-ballantines').text(textValue + ' ...');
                        $('.field-name-field-font .font-brush').text(textValue + ' ...');
                        $('.field-name-field-font .font-nelson').text(textValue + ' ...');
                        $('.field-name-field-font .font-monotype').text(textValue + ' ...');
                        $('.field-name-field-font .font-amaze').text(textValue + ' ...');
                        $('.field-name-field-font .font-script-mt').text(textValue + ' ...');
                        $('.field-name-field-font .font-fiolex').text(textValue + ' ...');

                        $('.field-name-field-font-br .font-brush').text(textValue + ' ...');
                        $('.field-name-field-font-br .font-nelson').text(textValue + ' ...');
                        $('.field-name-field-font-br .font-monotype').text(textValue + ' ...');
                        $('.field-name-field-font-br .font-amaze').text(textValue + ' ...');
                        $('.field-name-field-font-br .font-script-mt').text(textValue + ' ...');
                        $('.field-name-field-font-br .font-fiolex').text(textValue + ' ...');

                        stopLength = true;
                    }
                }
            });
        }
    };

    /*
     * Function to capitalize the first letter of the string.
     */
    function capitalizeFirstLetter(string, no_spaces) {
        if (no_spaces) {
            string = string.replace(/\s+/g, '');
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    /**
     * This makes the 'Clientul pt. care se plaseaza comanda' field's
     * label static, in order to fit on small displays.
     * Also, it changes the label's styling for the
     * Status/Discount/DueDate fields on the Quick Edit form
     * displayed on the commerce order list.
     */
    Drupal.behaviors.labelClientStatic = {
        attach: function ( context, settings ) {
            $('.field-name-field-client .form-item').removeClass('label-floating').addClass('label-static');
            $('.order-discount-field .form-item').removeClass('label-floating').addClass('label-static');
            $('.order-due-date-field .form-item').removeClass('label-floating').addClass('label-static');
            $('#commerce-backoffice-order-status-form .form-item-status.form-item').removeClass('label-floating').addClass('label-static');
            $('#commerce-backoffice-order-status-form .form-item-status.form-item .control-label').removeClass('element-invisible');
        }
    };


    /**
     * Process numeric fields
     */
    Drupal.behaviors.onNumberFocusSelect = {
        attach: function(context, settings) {
            /**
             * Add spinners
             */
            $('.field-type-number-integer input').each(function() {
                var thisElement = $(this);
                var inputValue = thisElement.val() == '' ? 0 : thisElement.val();

                thisElement.clone()
                    .attr('type','number')
                    .attr('min', '0')
                    .attr('max', '999')
                    .attr('value', inputValue)
                    .insertAfter(thisElement)
                    .prev().remove();
            });


            /*
             * Select the content in a numeric field on focus.
             */
            $('#edit-field-pret-um-fara-tva-aur input').on('click', function() {
                $(this).select();
            });


            /**
             * Prevent scrolling inside a number type field.
             * @see:
             *   https://stackoverflow.com/questions/9712295/disable-scrolling-on-input-type-number
             *   http://www.javascriptkit.com/javatutors/onmousewheel.shtml
             */
            // Determine the correct event to use (FF doesn't recognize mousewheel as of FF3.x)
            var mousewheelevt=(/Firefox/i.test(navigator.userAgent))? "DOMMouseScroll" : "mousewheel";

            // Prevent scrolling
            $(':input[type=number]').on('focus', function(e){
                // Select content when entering the field.
                $(this).select();

                // Prevent scrolling
                $(this).on(mousewheelevt, function(e){
                    e.preventDefault();
                });
            });
        }
    };


    /*
     * Init the material design library.
     */
    Drupal.behaviors.initMaterialDesign = {
        attach: function (context, settings) {
            $.material.init();

            // Only process the dropdowns used on node forms, not the ones in views.
            $(".form-select").each(function() {
                if ($(this).closest(".view").length == 0 &&
                    $(this).closest(".views-exposed-widget").length == 0 &&
                    $(this).closest("#commerce-price-add-more-wrapper").length == 0) {
                    $(this).dropdown();
                }
            });
        }
    };


    /*
     * Wedding Rings - disable "Inscriptionare exterioara" when the selected
     * ring model is not the one that allows this operation.
     */
    Drupal.behaviors.disableExtInscription = {
        attach: function (context, settings) {
            // Disable the "Inscriptionare exterioara" radio button by default.
            $('#edit-field-inscriptionare-und-3', context).attr("disabled", "disabled");

            // Enable/disable it depending on the context.
            // TEMPORARY: This section is disabled because no external engraving is performed anymore
            //            Uncomment this section when this service is available again.
            // $('.form-radio', context).on('click', function() {
            //     if ($('#edit-field-model-verigheta-und-16', context).is(':checked')) {
            //         $('#edit-field-inscriptionare-und-3', context).removeAttr("disabled");
            //     }
            //     else {
            //         $('#edit-field-inscriptionare-und-3', context).attr("disabled", "disabled");
            //         $('#edit-field-inscriptionare-und-3', context).prop('checked', false);
            //     }
            // });
            // TEMPORARY: enabled

            // TEMPORARY: When the external engraving service is not available, we should Hide
            //            the external engraving checkbox. Comment this line when the service
            //            becomes available again.
            $('#edit-field-inscriptionare-und-3', context).parent().hide();
            // TEMPORARY: END
        }
    };


    /*
     * Displays a warning message on the login screen when Caps Lock is enabled
     */
    Drupal.behaviors.capsLockWarning = {
        attach: function(context) {
            var $window = $(window);
            $('#edit-pass').keypress(function(e) {
                var s = String.fromCharCode( e.which );
                if ( s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey ) {
                    $('#capslockdiv p').show();
                }
                else {
                    $('#capslockdiv p').hide();
                }
            });
        }
    };


    /*
     * Hide Edit/Delete buttons if the node is opened in a ColorBox
     */
    Drupal.behaviors.colorboxHideOperations = {
        attach: function(context) {
            // if ($('#colorbox').css('display') == 'block') {
                // $('#colorbox .panel-heading a.btn').hide();
            // }
        }
    };


    /*
     * Check the "Cu lant" checkbox for the silver nickles with 14, 18 or 22 mm
     * in size.
     */
    Drupal.behaviors.setNecklaceStatus = {
        attach: function(context, settings) {

            if ($('#coliere-personalizate-node-form').length > 0) {
                $('#coliere-personalizate-node-form input').on('propertychange change click keyup input paste', function() {
                    if ($('#edit-field-material-und-5').is(':checked') &&
                        $('#edit-field-text-figurina-und-3').is(':checked') &&
                        ($('#edit-field-dim-banut-und-1').is(':checked') ||
                        $('#edit-field-dim-banut-und-2').is(':checked') ||
                        $('#edit-field-dim-banut-und-3').is(':checked'))) {

                        $('#edit-field-lant-und-1').prop("checked", true);
                        $('#edit-field-lant-und-1').attr("checked", true);
                        $('#edit-field-lant-und-1').prop("disabled", true);
                        $('#edit-field-lant-und-2').prop("disabled", true);
                   } else {
                        if ($('#edit-field-lant-und-1').prop("disabled")) {
                            $('#edit-field-lant-und-1').prop("checked", false);
                            $('#edit-field-lant-und-1').prop("disabled", false);
                            $('#edit-field-lant-und-2').prop("disabled", false);
                        }
                   }
               });
            }
        }
    };


    /*
     * Customize "Dimensiune personalizata" field behaviour
     * Neckless and Bracelets - "Figurina" and "Banut".
     */
    Drupal.behaviors.customDimensionField = {
        attach: function(context, settings) {

            // Make "Dimensiune personalizata" help block always visible
            $('.field-name-field-dim-custom .help-block', context).addClass('custom-dim-help').removeClass('help-block');

            // Prevent entering the predefined values (14,18,22)
            $('.field-name-field-dim-custom input', context).on('propertychange change click keyup input paste', function() {
                var custom_dim_value = parseInt($('.field-name-field-dim-custom input', context).val());
                if (custom_dim_value == 14 || custom_dim_value == 18 || custom_dim_value == 22) {
                    $('.custom-dim-help', context).addClass('emphasize-cell-error');
                    setTimeout(function(){
                        $('.field-name-field-dim-custom input', context).val('0');
                        $('.custom-dim-help', context).removeClass('emphasize-cell-error');
                    }, 1000);
                }
            });
        }
    };


    /*
     * Emphasize the fields shown by the Conditional Fields module
     * and set focus to the first relevant field
     */
    Drupal.behaviors.emphasizeAndFocusNeckless = {
        attach: function(context, settings) {

            // Text / Figurina fields - emphasize
            $('.form-item-field-text-figurina-und').on('click', function() {
                $('.field-name-field-text input').addClass('emphasize-cell');
                $('.field-name-field-desc-figurina input').addClass('emphasize-cell');
            });

            // Text / Figurina fields - focus
            $('.form-item-field-text-figurina-und').on('change', function() {
                if ($('.field-name-field-text:visible').length != 0) {
                    $('.field-name-field-text input').focus();
                }
                if ($('.field-name-field-desc-figurina:visible').length != 0) {
                    $('.field-name-field-desc-figurina input').focus();
                }
            });


            // Engraving fields - emphasize
            $('#edit-field-gravura-und-1').on('click', function() {
                $('.field-name-field-gravura-fata input').removeClass('emphasize-cell');
                $('.field-name-field-gravura-verso input').removeClass('emphasize-cell');
            });
            $('#edit-field-gravura-und-2').on('click', function() {
                $('.field-name-field-gravura-fata input').addClass('emphasize-cell');
                $('.field-name-field-gravura-verso input').removeClass('emphasize-cell');
            });
            $('#edit-field-gravura-und-3').on('click', function() {
                $('.field-name-field-gravura-fata input').removeClass('emphasize-cell');
                $('.field-name-field-gravura-verso input').addClass('emphasize-cell');
            });
            $('#edit-field-gravura-und-4').on('click', function() {
                $('.field-name-field-gravura-fata input').addClass('emphasize-cell');
                $('.field-name-field-gravura-verso input').addClass('emphasize-cell');
            });

            // Engraving fields - focus
            $('#edit-field-gravura-und-2').on('change', function() {
                $('.field-name-field-gravura-fata input').focus();
            });
            $('#edit-field-gravura-und-3').on('change', function() {
                $('.field-name-field-gravura-verso input').focus();
            });
            $('#edit-field-gravura-und-4').on('change', function() {
                $('.field-name-field-gravura-fata input').focus();
            });
        }
    };


    /*
     * Calculate product price - NECKLESS
     */
    Drupal.behaviors.calcNecklessPrice = {
        attach: function(context, settings) {

            if ($('#coliere-personalizate-node-form').length > 0) {

                // Set prices.
                var total_price = 0;
                var price = {};
                var prices = {
                    'init' : 49,
                    'chars' : [-12,0,12],      // 1-2 caractere, 3-9 caractere, 10-15 caractere
                    'neckless' : 10,
                    'stone' : 12.5,
                    'engraved_1' : 10,
                    'engraved_2' : 15,
                    'engraved_foto' : 39,
                    'banut_14' : 39,
                    'banut_18' : 44,
                    'banut_22' : 49,
                    'dimension' : [-12,0,12],   // 5-14 mm, 15-24 mm, 25-45 mm
                };

                // We only calculate the price for silver jewelry.
                $(document).ready(function() {
                    populatePriceFields('#coliere-personalizate-node-form');
                });

                // Detect changes on the form in order to recalculate the price
                $('#coliere-personalizate-node-form input').on( 'change input', function(e) {
                    populatePriceFields('#coliere-personalizate-node-form');
                });

                /*
                 * Function to populate the prices block fields.
                 */
                function populatePriceFields(form_id) {
                    var material = $(form_id + ' #edit-field-material input:checked').val();
                    if (material == 5) {    // Silver
                        $('#block-block-9').show();

                        // The gold price field should be 0 and the group hidden.
                        $('#edit-field-pret-um-fara-tva-aur input').attr('value', 0);

                        // The price fields shouldn't be visible when silver is selected.
                        $('.group-um-price').hide();

                        // Calculate values and display them in the corresponding fields.
                        price               =   calculateNecklessPrice(form_id, prices);
                        total_price         =   price.price * price.quantity;
                        total_discount      =   total_price * (Drupal.settings.calcProductPrice.discount / 100);
                        total_no_vat        =   total_price - total_discount;
                        total_vat_included  =   total_no_vat * 1.19;

                        $('#price-preview span.price-base').html(total_price.toFixed(2) + ' lei');
                        $('#price-preview span.price-discount').html(total_discount.toFixed(2) + ' lei');
                        $('#price-preview span.price-total-no-vat').html(total_no_vat.toFixed(2) + ' lei');
                        $('#price-preview span.price-total-vat').html(total_vat_included.toFixed(2) + ' lei');

                        // We assign the calculated price to the form's price field.
                        // This value will be used for display all around the website.
                        $('#edit-field-pret-calculat input').attr('value', total_vat_included.toFixed(2));

                        // We assign the Unit price w/o VAT and w/o discount to be used in invoices.
                        $('#edit-field-pret-um-fara-tva input').attr('value', price.price.toFixed(8));

                    } else if (material == 1 || material == 2 || material == 3 || material == 4) {    // Gold
                        $('#block-block-9').hide();

                        // If we are not dealing with gold, the price displayed on the website will be set to 0.
                        $('#edit-field-pret-calculat input').attr('value', 0);
                        $('#edit-field-pret-um-fara-tva input').attr('value', 0);

                        // The Unit price w/o VAT to be used in invoices.
                        // This will be made available to the users with 'calculate gold prices' permission
                        if (Drupal.settings.calcProductPrice.canCalculateGoldPrice) {
                            $('.group-um-price').show();
                        } else {
                            $('.group-um-price').hide();
                        }

                    } else {
                        // The price fields shouldn't be visible when no material is selected.
                        $('.group-um-price').hide();
                        $('#block-block-9').hide();
                    }
                }

                /*
                 * Function to calculate the price of a product NECKLESS order
                 */
                function calculateNecklessPrice(form_id, prices) {
                    if (form_id.length == 0) {
                        return 0;
                    }

                    // Se citesc valorile relevante pentru calculul preturilor din DOM
                    var price           =   0;
                    var price_init      =   0;
                    var jewelry_type    =   parseInt($(form_id + ' #edit-field-text-figurina input:checked').val());
                    var qty             =   parseInt($(form_id + ' #edit-field-cantitate input').val(), 10);
                    var neckless        =   $(form_id + ' #edit-field-lant input:checked').val() == 1 ? 1 : 0;
                    var chars_price     =   0;
                    var text_length     =   0;
                    var stones          =   parseInt($(form_id + ' #edit-field-nr-rosu input').val(), 10)   +
                                            parseInt($(form_id + ' #edit-field-nr-roz input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-purpuriu input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-violet input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-mov input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-turcoaz input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-albastru input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-verde input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-galben input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-cafeniu input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-negru input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-alb input').val(), 10);
                    var dimension_price =   0;
                    var engraved_faces_price =   0;

                    // Daca avem un colier cu text
                    if (jewelry_type == 1) {
                        var price_init              = prices.init;
                        var text_length             = $(form_id + ' #edit-field-text input').val().length;
                        var chars_price             = text_length >= 1 && text_length <= 2 ? prices.chars[0] :
                                                      (text_length >= 3 && text_length <= 9 ? prices.chars[1] :
                                                      (text_length >=10 && text_length <=15 ? prices.chars[2] : 0));
                        var engraved_faces_price    = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                    }

                    // Daca avem un colier cu figurina
                    if (jewelry_type == 2) {
                        var price_init              = prices.init;
                        var chars_price             = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                        var dimension               = parseInt($(form_id + ' #edit-field-dimensiune input:checked').val());
                        var dimension_price         = prices.dimension[dimension-1];    // The prices array index starts at position 0
                        var engraving               = parseInt($(form_id + ' #edit-field-gravura input:checked').val());
                        var engraved_faces_price    = 0;
                        if (engraving == 2 || engraving == 3) {
                            engraved_faces_price = prices.engraved_1;
                        }
                        if (engraving == 4) {
                            engraved_faces_price = prices.engraved_2;
                        }
                    }

                    // Daca avem un colier cu banut
                    if (jewelry_type == 3) {
                        var price_init              = 0;
                        var chars_price             = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                        var dimension               = parseInt($(form_id + ' #edit-field-dim-banut input:checked').val());
                        switch (dimension) {
                            case 1:
                                var dimension_price = prices.banut_14;
                                neckless = 1;
                                break;
                            case 2:
                                var dimension_price = prices.banut_18;
                                neckless = 1;
                                break;
                            case 3:
                                var dimension_price = prices.banut_22;
                                neckless = 1;
                                break;
                            case 4:
                                // Daca dimensiunea este custom, atunci pretul se calculeaza pornind de la formula pentru figurine,
                                // in functie de dimensiunea introdusa in campul "Dimensiune persnalizata".
                                price_init  =   prices.init; // Pentru dimensiunile personalizate, pretul de baza este cel de la figurine.
                                var custom_dimension = parseInt($(form_id + ' #edit-field-dim-custom input').val());
                                if (custom_dimension >= 5 && custom_dimension < 14) {
                                    var dimension_price = prices.dimension[0];
                                }
                                if (custom_dimension >= 15 && custom_dimension <= 24 && custom_dimension != 18 && custom_dimension != 22) {
                                    var dimension_price = prices.dimension[1];
                                }
                                if (custom_dimension >= 25 && custom_dimension <= 45) {
                                    var dimension_price = prices.dimension[2];
                                }

                                // Tratam si cazurile in care se introduc in campul "Dimensiune personalizata" valorile
                                // standard, in cazul in care velidarea nu functioneaza corect.
                                if (custom_dimension == 14) {
                                    var dimension_price = prices.banut_14;
                                    price_init = 0;
                                    neckless = 1;
                                }
                                if (custom_dimension == 18) {
                                    var dimension_price = prices.banut_18;
                                    price_init = 0;
                                    neckless = 1;
                                }
                                if (custom_dimension == 22) {
                                    var dimension_price = prices.banut_22;
                                    price_init = 0;
                                    neckless = 1;
                                }
                                break;
                        }

                        var engraving               = parseInt($(form_id + ' #edit-field-gravura input:checked').val());
                        var engraved_faces_price    = 0;

                        switch (engraving) {
                            case 2: // Gravare fata
                                var engraving_fata  = $(form_id + ' #edit-field-gravare-fata input:checked').val();
                                if (engraving_fata == 1) {
                                    engraved_faces_price = prices.engraved_1;
                                }
                                if (engraving_fata == 2) {
                                    engraved_faces_price = prices.engraved_foto;
                                }
                                break;
                            case 3: // Gravare verso
                                var engraving_verso = $(form_id + ' #edit-field-gravare-verso input:checked').val();
                                if (engraving_verso == 1) {
                                    engraved_faces_price = prices.engraved_1;
                                }
                                if (engraving_verso == 2) {
                                    engraved_faces_price = prices.engraved_foto;
                                }
                                break;
                            case 4: // Gravare ambele fete
                                var engraving_fata  = $(form_id + ' #edit-field-gravare-fata input:checked').val();
                                var engraving_verso = $(form_id + ' #edit-field-gravare-verso input:checked').val();
                                if (engraving_fata == 1 && engraving_verso == 1) {
                                    engraved_faces_price = prices.engraved_2;
                                } else {
                                    engraved_faces_price = (engraving_fata == 1 ? prices.engraved_1 : 0) +
                                                           (engraving_verso == 1 ? prices.engraved_1 : 0) +
                                                           (engraving_fata == 2 ? prices.engraved_foto : 0) +
                                                           (engraving_verso == 2 ? prices.engraved_foto : 0);
                                }
                                break;
                        }
                    }

                    // Calculare pret
                    price = price_init +
                            chars_price +
                            engraved_faces_price +
                            (price_init != 0 ? neckless * prices.neckless : 0) +        // Daca inca nu s-a selectat un tip de produs, sa nu se afiseze doar pretul lantisorului.
                            dimension_price +
                            (stones * prices.stone);

                    // Pregatire obiect de returnat
                    if (isNaN(price)) {
                        return_price = {
                            quantity: qty,
                            price: 0
                        };
                    } else {
                        return_price = {
                            quantity: qty,
                            price: price
                        };
                    }

                    return return_price;
                }
            }
        }
    };


    /*
     * Calculate product price - BRACELET
     */
    Drupal.behaviors.calcBraceletPrice = {
        attach: function(context, settings) {

            if ($('#bratara-node-form').length > 0) {

                // Set prices.
                var total_price = 0;
                var price = {};
                var prices = {
                    'init' : 49,
                    'chars' : [-12,0,12],         // 1-2 caractere, 3-9 caractere, 10-15 caractere
                    'neckless' : [10,1,4,0],      // lant, ata, snur
                    'stone' : 12.5,
                    'engraved_1' : 10,
                    'engraved_2' : 15,
                    'engraved_foto' : 39,
                    'banut_14' : 19.9,
                    'banut_18' : 23.9,
                    'banut_22' : 27.9,
                    'dimension' : [-12,0,12],   // 5-14 mm, 15-24 mm, 25-45 mm
                };

                // We only calculate the price for silver jewelry.
                $(document).ready(function() {
                    populatePriceFields('#bratara-node-form');
                });

                // Detect changes on the form in order to recalculate the price
                $('#bratara-node-form input').on( 'change input', function(e) {
                    populatePriceFields('#bratara-node-form');
                });

                /*
                 * Function to populate the prices block fields.
                 */
                function populatePriceFields(form_id) {
                    var material = $(form_id + ' #edit-field-material input:checked').val();
                    if (material == 5) {    // Silver
                        $('#block-block-9').show();

                        // The gold price field should be 0 and the group hidden.
                        $('#edit-field-pret-um-fara-tva-aur input').attr('value', 0);

                        // The price fields shouldn't be visible when silver is selected.
                        $('.group-um-price').hide();

                        // Calculate values and display them in the corresponding fields.
                        price               =   calculateBraceletPrice(form_id, prices);
                        total_price         =   price.price * price.quantity;
                        total_discount      =   total_price * (Drupal.settings.calcProductPrice.discount / 100);
                        total_no_vat        =   total_price - total_discount;
                        total_vat_included  =   total_no_vat * 1.19;

                        $('#price-preview span.price-base').html(total_price.toFixed(2) + ' lei');
                        $('#price-preview span.price-discount').html(total_discount.toFixed(2) + ' lei');
                        $('#price-preview span.price-total-no-vat').html(total_no_vat.toFixed(2) + ' lei');
                        $('#price-preview span.price-total-vat').html(total_vat_included.toFixed(2) + ' lei');

                        // We assign the calculated price to the form's price field.
                        // This value will be used for display all around the website.
                        $('#edit-field-pret-calculat input').attr('value', total_vat_included.toFixed(2));

                        // We assign the Unit price w/o VAT and w/o discount to be used in invoices.
                        $('#edit-field-pret-um-fara-tva input').attr('value', price.price.toFixed(8));

                    } else if (material == 1 || material == 2 || material == 3 || material == 4) {    // Gold
                        $('#block-block-9').hide();

                        // If we are not dealing with gold, the price displayed on the website will be set to 0.
                        $('#edit-field-pret-calculat input').attr('value', 0);
                        $('#edit-field-pret-um-fara-tva input').attr('value', 0);

                        // The Unit price w/o VAT to be used in invoices.
                        // This will be made available to the users having the 'calculate gold prices' permission.
                        if (Drupal.settings.calcProductPrice.canCalculateGoldPrice) {
                            $('.group-um-price').show();
                        } else {
                            $('.group-um-price').hide();
                        }

                    } else {
                        // The price fields shouldn't be visible when no material is selected.
                        $('.group-um-price').hide();
                        $('#block-block-9').hide();
                    }
                }

                /*
                 * Function to calculate the price of a product NECKLESS order
                 */
                function calculateBraceletPrice(form_id, prices) {

                    if (form_id.length == 0) {
                        return 0;
                    }

                    // Se citesc valorile relevante pentru calculul preturilor din DOM
                    var price           =   0;
                    var price_init      =   0;
                    var jewelry_type    =   parseInt($(form_id + ' #edit-field-text-figurina input:checked').val());
                    var qty             =   parseInt($(form_id + ' #edit-field-cantitate input').val(), 10);
                    var neckless        =   parseInt($(form_id + ' #edit-field-lant-br input:checked').val());
                    var chars_price     =   0;
                    var placuta         =   $(form_id + ' #edit-field-font-br input:checked').val() == 3 ? 1 : 0;
                    var text_length     =   0;
                    var stones          =   parseInt($(form_id + ' #edit-field-nr-rosu input').val(), 10)   +
                                            parseInt($(form_id + ' #edit-field-nr-roz input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-purpuriu input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-violet input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-mov input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-turcoaz input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-albastru input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-verde input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-galben input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-cafeniu input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-negru input').val(), 10) +
                                            parseInt($(form_id + ' #edit-field-nr-alb input').val(), 10);
                    var dimension_price =   0;
                    var engraved_faces_price =   0;

                    // Daca avem o bratara cu text
                    if (jewelry_type == 1) {
                        price_init = prices.init;

                        if (placuta == 0) {
                            var text_length =   $(form_id + ' #edit-field-text input').val().length;
                            var chars_price =   text_length >= 1 && text_length <= 2 ? prices.chars[0] :
                                                (text_length >= 3 && text_length <= 9 ? prices.chars[1] :
                                                (text_length >=10 && text_length <=15 ? prices.chars[2] : 0));
                        }
                        var engraved_faces_price = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                    }

                    // Daca avem o bratara cu figurina
                    if (jewelry_type == 2) {
                        price_init                  = prices.init;
                        var chars_price             = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                        var dimension               = $(form_id + ' #edit-field-dimensiune input:checked').val();
                        var dimension_price         = prices.dimension[dimension-1];    // The prices array index starts at position 0
                        var engraving               = $(form_id + ' #edit-field-gravura input:checked').val();
                        var engraved_faces_price    = 0;
                        if (engraving == 2 || engraving == 3) {
                            engraved_faces_price = prices.engraved_1;
                        }
                        if (engraving == 4) {
                            engraved_faces_price = prices.engraved_2;
                        }
                    }

                    // Daca avem o bratara cu banut
                    if (jewelry_type == 3) {
                        var price_init              = 0;
                        var chars_price             = 0;    // reset to 0 in order to avoid using conditions when calculating the price
                        var dimension               = parseInt($(form_id + ' #edit-field-dim-banut-bratara input:checked').val());
                        switch (dimension) {
                            case 1:
                                var dimension_price = prices.banut_14;
                                break;
                            case 2:
                                var dimension_price = prices.banut_18;
                                break;
                            case 3:
                                var dimension_price = prices.banut_22;
                                break;
                            case 4:
                                // Daca dimensiunea este custom, atunci pretul se calculeaza pornind de la formula pentru figurine,
                                // in functie de dimensiunea introdusa in campul "Dimensiune persnalizata".
                                price_init  =   prices.init; // Pentru dimensiunile personalizate, pretul de baza este cel de la figurine.
                                var custom_dimension = parseInt($(form_id + ' #edit-field-dim-custom input').val());
                                if (custom_dimension >= 5 && custom_dimension < 14) {
                                    var dimension_price = prices.dimension[0];
                                }
                                if (custom_dimension >= 15 && custom_dimension <= 24 && custom_dimension != 18 && custom_dimension != 22) {
                                    var dimension_price = prices.dimension[1];
                                }
                                if (custom_dimension >= 25 && custom_dimension <= 45) {
                                    var dimension_price = prices.dimension[2];
                                }

                                // Tratam si cazurile in care se introduc in campul "Dimensiune personalizata" valorile
                                // standard, in cazul in care velidarea nu functioneaza corect.
                                if (custom_dimension == 14) {
                                    var dimension_price = prices.banut_14;
                                    price_init = 0;
                                }
                                if (custom_dimension == 18) {
                                    var dimension_price = prices.banut_18;
                                    price_init = 0;
                                }
                                if (custom_dimension == 22) {
                                    var dimension_price = prices.banut_22;
                                    price_init = 0;
                                }
                                break;
                        }

                        var engraving               = parseInt($(form_id + ' #edit-field-gravura input:checked').val());
                        var engraved_faces_price    = 0;

                        switch (engraving) {
                            case 2: // Gravare fata
                                var engraving_fata  = $(form_id + ' #edit-field-gravare-fata input:checked').val();
                                if (engraving_fata == 1) {
                                    engraved_faces_price = prices.engraved_1;
                                }
                                if (engraving_fata == 2) {
                                    engraved_faces_price = prices.engraved_foto;
                                }
                                break;
                            case 3: // Gravare verso
                                var engraving_verso = $(form_id + ' #edit-field-gravare-verso input:checked').val();
                                if (engraving_verso == 1) {
                                    engraved_faces_price = prices.engraved_1;
                                }
                                if (engraving_verso == 2) {
                                    engraved_faces_price = prices.engraved_foto;
                                }
                                break;
                            case 4: // Gravare ambele fete
                                var engraving_fata  = $(form_id + ' #edit-field-gravare-fata input:checked').val();
                                var engraving_verso = $(form_id + ' #edit-field-gravare-verso input:checked').val();
                                if (engraving_fata == 1 && engraving_verso == 1) {
                                    engraved_faces_price = prices.engraved_2;
                                } else {
                                    engraved_faces_price = (engraving_fata == 1 ? prices.engraved_1 : 0) +
                                                           (engraving_verso == 1 ? prices.engraved_1 : 0) +
                                                           (engraving_fata == 2 ? prices.engraved_foto : 0) +
                                                           (engraving_verso == 2 ? prices.engraved_foto : 0);
                                }
                                break;
                        }
                    }


                    // Calculare pret
                    price = price_init +
                            chars_price +
                            engraved_faces_price +
                            (prices.neckless[neckless-1]) +         // The prices array index starts at position 0
                            dimension_price +
                            (stones * prices.stone);

                    // Pregatire obiect de returnat
                    if (isNaN(price)) {
                        return_price = {
                            quantity: qty,
                            price: 0
                        };
                    } else {
                        return_price = {
                            quantity: qty,
                            price: price
                        };
                    }
                    return return_price;
                }
            }
        }
    };


    /*
     * Calculate product price - Wedding Rings
     */
    Drupal.behaviors.calcRingsPrice = {
        attach: function(context, settings) {

            /*
             * Calculare preturi verighete ARGINT
             */
            if ($('#verighete-node-form').length > 0) {

                // Set prices.
                var total_price = 0;
                var price = {};
                var prices = {
                    'model' : [81,51,81,77,67,77,67,56,81,81,56,51,51,67,51,67],
                    'engraved_inside' : 8,
                    'engraved_outside' : 16,
                };


                // We only calculate the price for silver jewelry.
                $(document).ready(function() {
                    populatePriceFieldsRings('#verighete-node-form');
                });

                // Detect changes on the form in order to recalculate the price.
                $("#verighete-node-form input[type='radio']").on( 'change input', function(e) {
                    populatePriceFieldsRings('#verighete-node-form');
                });

                // Update price when the order owner is changed by the manager.
                $("#verighete-node-form #edit-field-client input").on( 'change input', function(e) {
                    populatePriceFieldsRings('#verighete-node-form');
                });

                /*
                 * Function to populate the prices block fields.
                 */
                function populatePriceFieldsRings(form_id) {
                    $('#block-block-9').show();

                    if (typeof localStorage['discount_other_user'] === 'undefined') {
                        localStorage['discount_other_user'] = 0;
                    }

                    // Daca cel care plaseaza comanda este manager si discount-ul este diferit
                    // de 0, inseamna ca manager-ul plaseaza comanda in numele altui user.
                    // Salvam discount-ul in localStorage si il folosim pentru calcularea
                    // pretului.
                    if (Drupal.settings.calcProductPrice.isManager &&
                        Drupal.settings.calcProductPrice.discount != 0) {
                        localStorage['discount_other_user'] = Drupal.settings.calcProductPrice.discount;
                    }

                    // Determine if the price should be calculated, or it should be
                    // loaded from localstorage. The 2nd option apply when the user
                    // is on the order form's 2nd or 3rd step.
                    var shouldCalculate = false;
                    if ($('#edit-field-observatii').length != 0) {
                        shouldCalculate = true;
                    }

                    // Calculate values and display them in the corresponding fields.
                    if (shouldCalculate) {
                        price               =   calculateRingsPrice(form_id, prices);
                        total_price         =   price.price * price.quantity;
                        total_discount      =   total_price *
                                                ((localStorage['discount_other_user'] == 0 ?
                                                Drupal.settings.calcProductPrice.discount :
                                                localStorage['discount_other_user']) / 100);
                        total_no_vat        =   total_price - total_discount;
                        total_vat_included  =   total_no_vat * 1.19;

                        localStorage['total_price']         =   total_price.toFixed(2);
                        localStorage['total_discount']      =   total_discount.toFixed(2);
                        localStorage['total_no_vat']        =   total_no_vat.toFixed(2);
                        localStorage['total_var_included']  =   total_vat_included.toFixed(2);

                        // We assign the calculated price to the form's price field.
                        // This value will be used for display all around the website.
                        $('#edit-field-total-comanda input').attr('value', total_vat_included.toFixed(2));

                        // We assign the Unit price w/o VAT and w/o discount to be used in invoices.
                        $('#edit-field-pret-um-fara-tva input').attr('value', price.price.toFixed(8));
                    }
                    else {
                        if (localStorage['discount_other_user'] != 0) {
                            localStorage['total_discount']      =   (localStorage['total_price'] *
                                                                    localStorage['discount_other_user'] / 100).toFixed(2);
                            localStorage['total_no_vat']        =   (localStorage['total_price'] -
                                                                    localStorage['total_discount']).toFixed(2);
                            localStorage['total_var_included']  =   (localStorage['total_no_vat'] * 1.19).toFixed(2);
                        }
                    }

                    $('#price-preview span.price-base').html((typeof localStorage['total_price'] === 'undefined' ? 0 : localStorage['total_price']) + ' lei');
                    $('#price-preview span.price-discount').html((typeof localStorage['total_discount'] === 'undefined' ? 0 : localStorage['total_discount']) + ' lei');
                    $('#price-preview span.price-total-no-vat').html((typeof localStorage['total_no_vat'] === 'undefined' ? 0 : localStorage['total_no_vat']) + ' lei');
                    $('#price-preview span.price-total-vat').html((typeof localStorage['total_var_included'] === 'undefined' ? 0 : localStorage['total_var_included']) + ' lei');
                }


                /*
                 * Function to calculate the price of a product NECKLESS order
                 */
                function calculateRingsPrice(form_id, prices) {
                    if (form_id.length == 0) {
                        return 0;
                    }

                    // Se citesc valorile relevante pentru calculul preturilor din DOM
                    var price           =   0;
                    var ring_model      =   $(form_id + ' #edit-field-model-verigheta input:checked').val();
                    var model_price     =   typeof ring_model === 'undefined' ? 0 : prices.model[ring_model-1];  // The prices array index starts at position 0

                    var qty_checkbox    =   $(form_id + ' #edit-field-sex input:checked').val();
                    var qty             =   (qty_checkbox == 1 || qty_checkbox == 2) ? 1 : (qty_checkbox == 3 ? 2 : 0);

                    var engraving       =   $(form_id + ' #edit-field-inscriptionare input:checked').val();
                    var engraving_price =   engraving == 2 ? prices.engraved_inside : (engraving == 3 ? prices.engraved_outside : 0);

                    // Calculare pret unitar fara TVA si discount
                    price = model_price + engraving_price;

                    // Pregatire obiect de returnat
                    if (isNaN(price)) {
                        return_price = {
                            quantity: qty,
                            price: 0
                        };
                    } else {
                        return_price = {
                            quantity: qty,
                            price: price
                        };
                    }

                    return return_price;
                }
            }
            else {
                // Daca nu se editeaza formularul pentru verighete,
                // variabilele din localStorage sunt eliminate
                localStorage.removeItem('total_price');
                localStorage.removeItem('total_discount');
                localStorage.removeItem('total_no_vat');
                localStorage.removeItem('total_var_included');
                localStorage.removeItem('discount_other_user');
            }
        }
    };


    /*
     * FIX: Remove "Detalii livrare" title from the 1st Step of the order form.
     */
    Drupal.behaviors.removeDeliveryDetails = {
        attach: function(context) {
            if ($(".group-livrare .group-adresa input")
                .not($(".node .group-livrare .group-adresa input"))
                .length == 0) {
                $('.step-detalii-livrare').remove();
                $(".group-livrare").not($(".node .group-livrare")).not($(".entity .group-livrare")).remove();
            }
        }
    };


    /*
     * Hide "Lant" option for the golden bracelets.
     *
     * !!! TEMPORARY
     */
    Drupal.behaviors.alterGoldBraceletOptions = {
      attach: function(context, settings) {
        if ($('#bratara-node-form').length > 0) {

          // Hide it when the page loads for the following situations:
          // - no material is selected yet
          // - there were errors on the form and it has been reloaded.
          $(document).ready(function() {
            var material = parseInt($('#bratara-node-form #edit-field-material input:checked').val());
            if (material != 5) {
              $("label[for='edit-field-lant-br-und-1']").fadeOut('fast');
            } else {
              $("label[for='edit-field-lant-br-und-1']").fadeIn('fast');
            }
          });

          // Hide it when the user changes the form items.
          $('#bratara-node-form input').on( 'change input', function(e) {
            var material = parseInt($('#bratara-node-form #edit-field-material input:checked').val());
            if (material != 5) {
              $("label[for='edit-field-lant-br-und-1']").fadeOut('fast');
            } else {
              $("label[for='edit-field-lant-br-und-1']").fadeIn('fast');
            }
          });
        }
      }
    };

// })(jQuery);
})(jQuery, Drupal);
